export const isTextEllipsed = (element: HTMLElement): boolean => {
  return element.scrollWidth > element.offsetWidth;
};
